// components/TextInput.tsx
import { useFormContext } from 'react-hook-form';

import { cn } from '@/lib/utils';
import type { GeneralFormProps } from '@/types/general';

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { Switch } from '../ui/switch';

type Props = {
  className?: string;
  value?: boolean;
  helperText?: string;
} & Omit<GeneralFormProps, 'description'>;

function RHFShadcnSwitch({
  name,
  title,
  helperText,
  value: externalValue,
  onChange: externalOnChange,
  className,
  required,

  disabled = false,
}: Props) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem
          className={cn(
            'flex w-full flex-row items-center justify-between gap-3',
            className,
          )}
        >
          <div className="flex flex-col">
            {title !== undefined && title !== '' && (
              <FormLabel
                className={cn(
                  'type-label-l text-foreground',
                  disabled === false && 'cursor-pointer',
                )}
              >
                {title}
                {required === true && (
                  <span aria-label="required" className="text-error ml-1">*</span>
                )}
              </FormLabel>
            )}
            {helperText !== undefined && helperText !== '' && (
              <FormDescription className="mt-1 type-body-s text-on-surface-variant">
                {helperText}
              </FormDescription>
            )}
            <FormMessage className="mt-1.5" />
          </div>
          <FormControl>
            <Switch
              required={required}
              data-testid={field.name}
              disabled={disabled}
              onCheckedChange={(e) => {
                if (externalOnChange) {
                  externalOnChange(e);
                  return;
                }
                field.onChange(e);
              }}
              checked={field.value === true || externalValue === true}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}

export default RHFShadcnSwitch;
